if (!customElements.get('component-countdown')) {
  customElements.define(
    'component-countdown',
    class Countdown extends HTMLElement {
      // static observedAttributes = ['date', 'time'];

      constructor() {
        super();
        this.elements = {
          days: this.querySelector('.days'),
          hours: this.querySelector('.hours'),
          minutes: this.querySelector('.minutes'),
          seconds: this.querySelector('.seconds')
        };
        this.showUnits = this.getAttribute('data-show-units');
        this.formatUnits = this.getAttribute('data-format-units');
        this.update = this.update.bind(this);
        this.initTimer = this.initTimer.bind(this);
      }

      connectedCallback() {
        if (!this.hasAttribute('role')) this.setAttribute('role', 'timer');
        if (!this.hasAttribute('aria-live')) this.setAttribute('aria-live', 'polite');
        this.update();
      }

      initTimer() {
        const unites = {
          second: 1000,
          minute: 1000 * 60,
          hour: 1000 * 60 * 60,
          day: 1000 * 60 * 60 * 24,
        }

        const currentDate = new Date().getTime();
        const endDate = new Date(`${this.date}T${this.time}`).getTime();

        const timeDiffrence = Math.abs(endDate - currentDate);

        if (!timeDiffrence) {
          this.dispatchEvent(
            new Event('ended', {bubbles: true, composed: true}));
          clearInterval(this.interval);
        };

        this.timeLeft = [Math.floor(timeDiffrence / unites.day),
          Math.floor((timeDiffrence % unites.day) / unites.hour),
          Math.floor((timeDiffrence % unites.hour) / unites.minute),
          Math.floor((timeDiffrence % unites.minute) / unites.second)]
      }

      update() {
        let libelle = ["d","u","m","s"];
        if (this.formatUnits !== null && this.formatUnits !== undefined && this.formatUnits.length > 0) {
          libelle = this.formatUnits.split('-');
        }

        this.interval = setInterval(() => {
          this.initTimer();
          Object.values(this.elements).forEach((element, index) => {
            if (this.showUnits === 'true') {
              element.innerText = ('0' + this.timeLeft[index]).slice(-2) + libelle[index];
            } else {
              element.innerText = ('0' + this.timeLeft[index]).slice(-2);
            }
          });
        }, 1000);
      }

      get time() {
        return this.getAttribute('time');
      }

      get date() {
        return this.getAttribute('date');
      }
    },
  );
};
